import { DateTime } from "luxon";

export const calcHours = (start: string, end: string): string | null => {
    if (!start || !end) return null;
    const [sh, sm] = start.split(":").map(Number);
    const [eh, em] = end.split(":").map(Number);
    const startMinutes = sh * 60 + sm;
    const endMinutes = eh * 60 + em;
    if (endMinutes <= startMinutes) return null;
    const diffMinutes = endMinutes - startMinutes;
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    return `${hours}h ${minutes}m`;
};

export const toISO = (time: string, referenceDate: string): string => {
    const [hours, minutes] = time.split(":").map(Number);
    const dt = DateTime.fromISO(referenceDate).set({ hour: hours, minute: minutes, second: 0, millisecond: 0 });
    return dt.toUTC().toISO();
};